import Vue from 'vue';
export const MoveIcon = Vue.extend({
    functional: true,
    name: 'MoveIcon',
    render(createElement, ctx) {
        return (<svg xmlns="http://www.w3.org/2000/svg" height="100%" width="100%" version="1.1" viewBox="0 0 30 30">
                <rect style="fill:rgba(0, 0, 0, 0)" id="rect4559" height="30" width="30" y="0" x="0" class="cls-1"/>
                <path style="fill:#222731;stroke-width:2.1072011" id="path4561" 
        // tslint:disable-next-line: max-line-length
        d="M 0.08101695,13.976359 H 26.547461 L 16.011457,3.4403529 17.275777,2.1971047 29.918983,14.840311 17.275777,27.483517 16.011457,26.219197 26.547461,15.683191 H 0.08101695 Z" class="cls-2"/>
            </svg>);
    },
});
//# sourceMappingURL=MoveIcon.jsx.map